import { render, staticRenderFns } from "./BlockContactsPage.vue?vue&type=template&id=934db6d8&scoped=true"
import script from "./BlockContactsPage.vue?vue&type=script&lang=js"
export * from "./BlockContactsPage.vue?vue&type=script&lang=js"
import style0 from "./BlockContactsPage.vue?vue&type=style&index=0&id=934db6d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "934db6d8",
  null
  
)

export default component.exports